module.exports = __webpack_public_path__ + "img/red-resources-banner.021faf97.png";